import { styled } from '@mui/material/styles';

export const StyledSignImage = styled('img')(({ theme }) => ({
  width: '50%',
  border: `1px solid ${theme.palette.neutral.variation80}`,
  borderRadius: '12px',
  backgroundColor: theme.palette.neutral.variation100,
}));
